<form class="user-info-view" [formGroup]="form">
  <div class="user-info-view__block">
    <app-photo
      class="image"
      [text]="data | userDisplayableName: 'short'"
      [type]="'photo'"
      [id]="data?.photoId"
      [height]="isLargeScreen ? '144px' : '96px'"
      [width]="isLargeScreen ? '144px' : '96px'"
      [borderRadius]="isLargeScreen ? '144px' : '96px'"
      [rounded]="true"
      [loading]="loading"
    ></app-photo>

    <app-field
      class="field"
      tabindex="2"
      [name]="'components.userInfo.fields.lastName' | translate"
      [tuiSkeleton]="loading"
      [typeName]="'text'"
      [value]="form.get('lastName')?.value"
      [size]="tuiElementLargeSize"
    ></app-field>

    <app-field
      *ngIf="form.get('firstName')?.value"
      class="field"
      tabindex="3"
      [name]="'components.userInfo.fields.firstName' | translate"
      [tuiSkeleton]="loading"
      [typeName]="'text'"
      [value]="form.get('firstName')?.value"
      [size]="tuiElementLargeSize"
    ></app-field>

    <app-field
      *ngIf="form.get('middleName')?.value"
      class="field"
      tabindex="4"
      [name]="'components.userInfo.fields.middleName' | translate"
      [tuiSkeleton]="loading"
      [typeName]="'text'"
      [value]="form.get('middleName')?.value"
      [size]="tuiElementLargeSize"
    ></app-field>

    <app-field
      *ngIf="form.get('birthDate')?.value"
      class="field"
      tabindex="5"
      [name]="'components.userInfo.fields.birthDate' | translate"
      [tuiSkeleton]="loading"
      [typeName]="'text'"
      [value]="form.get('birthDate')?.value"
      [size]="tuiElementLargeSize"
    ></app-field>

    <ng-container *ngIf="!(allowOnlyYourShortProfileViewing$ | async)">
      <app-field
        *ngIf="form.get('phone')?.value && (allowPhoneFieldViewing$ | async)"
        tabindex="6"
        [name]="'components.userInfo.fields.mobilePhone' | translate"
        [tuiSkeleton]="loading"
        [typeName]="'phone'"
        [value]="form.get('phone')?.value"
        [size]="tuiElementLargeSize"
      ></app-field>
    </ng-container>

    <app-field
      *ngIf="form.get('email')?.value && (allowEmailFieldViewing$ | async)"
      class="field"
      tabindex="7"
      [name]="'components.userInfo.fields.email' | translate"
      [tuiSkeleton]="loading"
      [typeName]="'email'"
      [value]="form.get('email')?.value"
      [size]="tuiElementLargeSize"
    ></app-field>

    <ng-container *ngIf="!(allowOnlyYourShortProfileViewing$ | async)">
      <ng-container *ngIf="form.get('defaultJobTitlesIds')?.value?.length">
        <tui-multi-select
          *tuiLet="jobsForViewing$ | async as jobs"
          tabindex="8"
          formControlName="defaultJobTitlesIds"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [editable]="false"
          [stringify]="stringifyJobTitle"
          [readOnly]="true"
        >
          {{ 'field.jobTitle' | customNames }}
          <tui-data-list *tuiDataList tuiMultiSelectGroup>
            <button *ngFor="let job of jobs" tuiOption [value]="job.id">
              {{ job.jobTitleName }}
            </button>
          </tui-data-list>
        </tui-multi-select>
      </ng-container>

      <app-field
        *ngIf="form.get('resources')?.value"
        class="field"
        tabindex="9"
        [name]="'components.userInfo.fields.resources' | translate"
        [tuiSkeleton]="loading"
        [typeName]="'text'"
        [value]="form.get('resources')?.value"
        [size]="tuiElementLargeSize"
      ></app-field>

      <app-field
        *ngIf="form.get('hobbies')?.value"
        class="field"
        tabindex="10"
        [name]="'components.userInfo.fields.hobbies' | translate"
        [tuiSkeleton]="loading"
        [typeName]="'text'"
        [value]="form.get('hobbies')?.value"
        [size]="tuiElementLargeSize"
      ></app-field>

      <ng-container *ngIf="allowSpecialFieldsForAssociationViewing$ | async">
        <app-field
          *ngIf="data?.curatorId"
          class="field"
          tabindex="11"
          [name]="'components.userInfo.fields.curator' | translate"
          [tuiSkeleton]="loading"
          [typeName]="'user'"
          [value]="data?.curatorId"
          [size]="tuiElementLargeSize"
        ></app-field>

        <tui-input-date
          *ngIf="form.get('authorityValidTill')?.value"
          tabindex="12"
          formControlName="authorityValidTill"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [readOnly]="true"
        >
          {{ 'components.userInfo.fields.authorityValidTill' | translate }}
        </tui-input-date>

        <app-field
          *ngIf="data && data.paymentDetailsId"
          tabindex="13"
          [name]="'label.userProfileAttachment' | customNames"
          [typeName]="'file'"
          [value]="data.paymentDetailsId"
          [size]="tuiElementLargeSize"
          [tuiSkeleton]="loading"
        ></app-field>
      </ng-container>

      <label
        *ngIf="(allowSpecialFieldsForAssociationViewing$ | async) && form.value.isFeePaid"
        class="field"
        [tuiBlock]="tuiElementSmallSize"
        [appearance]="'readonly-field'"
        [style.justify-content]="'space-between'"
      >
        {{ 'components.userInfo.fields.feeNotPaid' | translate }}
        <input
          tuiCheckbox
          type="checkbox"
          tabindex="14"
          [size]="'s'"
          [checked]="isFeePaidControl.value"
          [class.tui-skeleton]="loading"
          [class.tui-skeleton_text]="loading"
        />
      </label>
    </ng-container>

    <ng-container *ngIf="allowLoyaltyFieldsViewing$ | async">
      <app-search-cities-view
        *ngIf="form.get('city')?.value as city"
        class="field"
        tabindex="15"
        [loading]="loading"
        [city]="city"
        [size]="tuiElementLargeSize"
      ></app-search-cities-view>

      <lp-categories-field
        *ngIf="form.get('favoriteCategories')?.value?.length"
        formControlName="favoriteCategories"
        [externalLoading]="loading"
        [textfieldSize]="tuiElementLargeSize"
      >
        {{ 'components.userInfo.fields.favoriteCategories' | translate }}
      </lp-categories-field>
    </ng-container>
  </div>

  <ng-container *ngIf="!(allowOnlyYourShortProfileViewing$ | async)">
    <div class="user-info-view__contacts">
      <ng-container *ngFor="let contact of form.get('contacts')?.value">
        <div *ngIf="contact.contact" class="contact">
          <app-field
            class="field"
            [tuiSkeleton]="loading"
            [typeId]="contact.contactTypeId"
            [name]="contact.description"
            [value]="contact.contact"
            [size]="tuiElementLargeSize"
          ></app-field>
        </div>
      </ng-container>
    </div>

    <div class="user-info-view__organisations" formArrayName="organisations">
      <tui-island *ngFor="let organisation of organisations.controls; let oIndex = index" class="tui-island">
        <tui-icon
          *ngIf="organisation.get('isDefault')?.value"
          class="tui-island__icon tui-island__icon_isDefault"
          [icon]="'@tui.star'"
          [background]="'@tui.star-filled'"
        ></tui-icon>

        <app-link
          class="tui-island__title"
          [routerLink]="'/organisation/' + organisation.get('organisationId')?.value"
          [displayText]="organisation.get('organisationName')?.value"
        ></app-link>

        <div class="tui-island__paragraph item" [formGroupName]="oIndex">
          <app-field
            tabindex="15"
            [name]="'components.userInfo.fields.jobTitlesDescription' | translate"
            [tuiSkeleton]="loading"
            [typeName]="'text'"
            [value]="organisation.get('jobTitlesDescription')?.value"
            [size]="tuiElementLargeSize"
          ></app-field>

          <ng-container
            *ngIf="!organisation.get('isDefault')?.value && organisation.get('jobTitlesIds')?.value?.length"
          >
            <tui-multi-select
              *tuiLet="jobsForViewing$ | async as jobs"
              tabindex="16"
              formControlName="jobTitlesIds"
              [tuiSkeleton]="loading"
              [tuiTextfieldSize]="tuiElementLargeSize"
              [tuiTextfieldCleaner]="true"
              [editable]="false"
              [stringify]="stringifyJobTitle"
              [readOnly]="true"
            >
              {{ 'field.jobTitle' | customNames }}
              <tui-data-list *tuiDataList tuiMultiSelectGroup>
                <button *ngFor="let job of jobs" tuiOption [value]="job.id">
                  {{ job.jobTitleName }}
                </button>
              </tui-data-list>
            </tui-multi-select>
          </ng-container>

          <div *ngIf="allowRoleFieldViewing$ | async">
            <tui-select
              *tuiLet="roles$ | async as roles"
              tabindex="17"
              formControlName="roleIds"
              [class.tui-skeleton]="loading || !roles?.length"
              [class.tui-skeleton_text]="loading || !roles?.length"
              [valueContent]="roles ? rolesStringify(roles) : ''"
              [tuiTextfieldSize]="tuiElementLargeSize"
              [readOnly]="true"
            >
              {{ 'components.userInfo.fields.role' | translate }}
              <tui-data-list *tuiDataList>
                <button *ngFor="let role of roles" tuiOption [value]="role.id">
                  {{ role.description }}
                </button>
              </tui-data-list>
            </tui-select>
          </div>
        </div>
      </tui-island>
    </div>
  </ng-container>

  <div *ngIf="!loading" class="user-info-view__buttons">
    <ng-container *ngIf="authUser$ | async as authUser">
      <ng-container *ngxPermissionsOnly="'userChatButtonViewing'">
        <ng-container *ngxPermissionsOnly="'pageChatsInnerViewing'">
          <button
            *ngIf="data && data.id && data.id !== authUser.id && internalMessengerUsed"
            tuiButton
            class="user-info-view-button"
            tabindex="18"
            type="button"
            appearance="primary"
            [size]="tuiElementLargeSize"
            (click)="onClickChatButton()"
          >
            {{ 'common.buttons.write' | translate }}
          </button>
        </ng-container>

        <div
          *ngIf="data && data.telegramId && data.telegramId !== authUser.telegramId && isTelegramLogged"
          waitTelegramChats
        >
          <button
            tuiIconButton
            class="user-info-view-button"
            tabindex="18"
            type="button"
            iconStart="@tui.send"
            appearance="primary"
            [size]="tuiElementLargeSize"
            (click)="onClickTelegramChatButton()"
          >
            {{ 'common.buttons.write' | translate }}
          </button>
        </div>
      </ng-container>

      <button
        *ngIf="allowEditing$ | async"
        tuiButton
        class="user-info-view-button"
        tabindex="19"
        type="button"
        appearance="primary"
        [size]="tuiElementLargeSize"
        (click)="onClickEditButton()"
      >
        {{ 'common.buttons.edit' | translate }}
      </button>

      <button
        *ngIf="data?.id && allowDeleting"
        tuiButton
        class="user-info-view-button"
        tabindex="20"
        type="button"
        appearance="accent"
        [size]="tuiElementLargeSize"
        (click)="onClickDeleteButton()"
      >
        {{ 'common.buttons.delete' | translate }}
      </button>

      <button
        *ngIf="data?.id && allowExcluding"
        tuiButton
        class="user-info-view-button"
        tabindex="20"
        type="button"
        appearance="accent"
        [size]="tuiElementLargeSize"
        (click)="onClickExcludeButton()"
      >
        {{ 'common.buttons.exclude' | translate }}
      </button>

      <app-reports-button
        [size]="tuiElementLargeSize"
        [reportType]="'users'"
        [hiddenReportData]="{ userId: data?.id }"
      ></app-reports-button>
    </ng-container>
  </div>

  <div class="user-info-view__block">
    <div *ngIf="committeesList?.length" class="field" tabindex="22" [tuiSkeleton]="loading">
      <div class="committees-list-title">{{ 'components.userInfo.labels.consist' | translate }}</div>

      <app-new-list
        [items]="committeesList"
        [itemContentTmp]="committeeTmp"
        (selectedIdChange)="onSelectedCommitteeIdChange($event)"
      ></app-new-list>
    </div>
  </div>
</form>

<ng-template #committeeTmp let-item>
  <new-list-item-committee [item]="item"></new-list-item-committee>
</ng-template>
